<template>
  <pl-dialog
    :title="'Book Virtual PD Session'"
    :size="'xl'"
    :disableOutsideClick="true"
    @close="$emit('close')"
  >
    <body class="px-7 overflow-auto">
      <div class="my-7 flex justify-center font-semibold text-base">
        Request time for an introductory tour and interactive demonstration of
        Parlay for a group of educators at your school or district.
      </div>
      <div id="hubspotForm" v-once></div>
    </body>
  </pl-dialog>
</template>
<script>
  export default {
    mounted() {
      const script = document.createElement('script');
      script.charset = 'utf-8';
      script.type = 'text/javascript';
      script.src = '//js.hsforms.net/forms/v2.js';
      (document.body || document.head).appendChild(script);
      script.addEventListener('load', () => {
        if (window.hbspt) {
          window.hbspt.forms.create({
            region: 'na1',
            portalId: '2529635',
            formId: '4adfb842-8f7d-458b-975e-42289106f664',
            target: '#hubspotForm',
          });
        }
      });
    },
  };
</script>



// WEBPACK FOOTER //
// virtualPdSessionModal.vue?118abc44